<template>
  <div class="page-container">
    <div class="content-container">
      <!-- Display the sector title -->
      <h1 class="sector-title">{{ sectorTitle }}</h1>

      <div class="card-container">
        <div
          v-for="(card, index) in paginatedCards"
          :key="index"
          class="card"
          @click="handleCardClick(card)"
        >
          <div class="card-image-container">
            <img :src="card.photo" :alt="card.title" class="card-image" />
          </div>
          <div class="card-title">{{ card.name }}</div>
        </div>
      </div>

      <!-- Pagination -->
      <div v-if="cards.length > cardsPerPage" class="pagination">
        <button
          @click="prevPage"
          :disabled="currentPage === 1"
          class="pagination-button prev-button"
        >
          Previous
        </button>
        <span class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }}
        </span>
        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="pagination-button next-button"
        >
          Next
        </button>
      </div>
    </div>
   
  </div>
   <!-- <FooterComponent></FooterComponent> -->
</template>
  
  <script>
    // import FooterComponent from '@/components/common/Footer.vue';
    
    export default {
      // components: {
      //   FooterComponent,
      // },
      props: {
        cards: {
          type: Array,
          required: true, // Cards data must be provided by the parent
        },
        sectorTitle: {
          type: String,
          required: true, // Sector title must be provided by the parent
        },
        cardsPerPage: {
          type: Number,
          default: 10, // Default number of cards per page
        },
      },
      data() {
        return {
          currentPage: 1, // Current page for pagination
        };
      },
      
      computed: {
        totalPages() {
          return Math.ceil(this.cards.length / this.cardsPerPage);
        },
        paginatedCards() {
          const start = (this.currentPage - 1) * this.cardsPerPage;
          const end = start + this.cardsPerPage;
          return this.cards.slice(start, end);
        },
      },
      methods: {
        nextPage() {
          if (this.currentPage < this.totalPages) {
            this.currentPage++;
          }
        },
        prevPage() {
          if (this.currentPage > 1) {
            this.currentPage--;
          }
        },
        // handleCardClick(card) {
        //   this.$emit('card-clicked', card); // Emit event for parent component
        // },
        handleCardClick(card) {
          if (card.name === 'PUBLIC PERSONALITIES' || card.name === 'PERSONNALITÉS PUBLIQUES') {
            this.$router.push('/public-personalities');
          } else {
            // Your default card click handling logic here
            this.$emit('card-clicked', card); 
            // Or route to other paths based on other conditions
          }
        }
      },
      
    };
  </script>
  
  <style scoped>
  /* Reset default margin and padding */
  body, html {
    margin: 0;
    padding: 0;
    overflow-x: hidden; /* Prevent horizontal scroll */
  }
  
  .page-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh; /* Ensure the container takes at least the full viewport height */
    width: 100%; /* Full width */
    margin: 0; /* Remove default margin */
    padding: 0; /* Remove default padding */
    box-sizing: border-box; /* Include padding in width and height */
    overflow-x: hidden; /* Prevent horizontal scroll */
  }
  
  .content-container {
    flex: 1; /* Allow the content to grow and take up remaining space */
    padding: 20px;
    width: 100%; /* Full width */
    max-width: 1200px; /* Limit content width */
    margin: 0 auto; /* Center the content */
    box-sizing: border-box; /* Include padding in width */
  }
  
  .card-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 5 columns */
    grid-template-rows: repeat(2, 1fr); /* 2 rows */
    gap: 16px;
    width: 100%; /* Full width */
  }
  
  .card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    background-color: #fff;
  }
  
  .card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
  
  .card-image-container {
    width: 100%;
    height: 150px;
    overflow: hidden;
    position: relative;
  }
  
  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .card:hover .card-image {
    transform: scale(1.1);
  }
  
  .card-title {
    padding: 12px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    transition: color 0.3s ease;
  }
  
  .card:hover .card-title {
    color: #4169e1;
  }
  
  .pagination {
    display: flex;
    justify-content: space-between; /* Space between buttons */
    align-items: center;
    width: 100%;
    max-width: 1200px; /* Match card container width */
    margin-top: 20px;
  }
  
  .pagination-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  
  .pagination-button:disabled {
    background-color: #ddd;
    cursor: not-allowed;
  }
  
  .prev-button {
    background-color: #ff4d4d; /* Red */
    color: white;
  }
  
  .prev-button:hover:not(:disabled) {
    background-color: #cc0000; /* Darker red on hover */
  }
  
  .next-button {
    background-color: #4169e1; /* Blue */
    color: white;
  }
  
  .next-button:hover:not(:disabled) {
    background-color: #304f9f; /* Darker blue on hover */
  }
  
  .pagination-info {
    font-size: 14px;
    color: #666;
  }
  
  .footer {
    width: 100%; /* Full width */
    background-color: #f8f9fa; /* Example footer background color */
    padding: 20px;
    text-align: center;
    border-top: 1px solid #e0e0e0;
    flex-shrink: 0; /* Prevent the footer from shrinking */
    box-sizing: border-box; /* Include padding in width */
  }
  .sector-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  color: #4169e1;
  }
  
  /* Responsive Design */
  @media (max-width: 1200px) {
    .card-container {
      grid-template-columns: repeat(3, 1fr); /* 3 columns for smaller screens */
      grid-template-rows: repeat(4, 1fr); /* 4 rows */
    }
  }
  
  @media (max-width: 768px) {
    .card-container {
      grid-template-columns: repeat(2, 1fr); /* 2 columns for tablets */
      grid-template-rows: repeat(5, 1fr); /* 5 rows */
    }
  }
  
  @media (max-width: 480px) {
    .card-container {
      grid-template-columns: repeat(1, 1fr); /* 1 column for mobile */
      grid-template-rows: repeat(5, 1fr); /* 10 rows */
    }
  }
  </style>